module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "HowTobuy"
  }, [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "HowTobuy_wrap"
  }, [_c('h1', {
    staticClass: "howtoway-title"
  }, [_vm._v(_vm._s(_vm.$t('footer_howtoway')))]), _vm._v(" "), _c('div', {
    staticClass: "HowTobuy_step"
  }, [_c('div', {
    staticClass: "HowTobuy_step_detail"
  }, [_c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('howtobuy_step1')) + "\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('howtobuy_step1_content')) + "\n                ")])]), _vm._v(" "), (this.Howlang == 'cn') ? _c('img', {
    staticStyle: {
      "max-width": "1000px",
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/howtobuy1.jpg")
    }
  }) : (this.Howlang == 'sc') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step1_sc@2x.jpg")
    }
  }) : (this.Howlang == 'en') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step1_en@2x.jpg")
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "HowTobuy_step"
  }, [_c('div', {
    staticClass: "HowTobuy_step_detail"
  }, [_c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('howtobuy_step2')) + "\n                ")])]), _vm._v(" "), (this.Howlang == 'sc') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step2_tc@2x.jpg")
    }
  }) : (this.Howlang == 'cn') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step2_sc@2x.jpg")
    }
  }) : (this.Howlang == 'en') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step2_en@2x.jpg")
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "HowTobuy_step"
  }, [_c('div', {
    staticClass: "HowTobuy_step_detail"
  }, [_c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('howtobuy_step3')) + "\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('howtobuy_step3_content1')) + "\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('howtobuy_step3_content2')) + "\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('howtobuy_step3_content3')) + "\n                ")])]), _vm._v(" "), (this.Howlang == 'sc') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step3_tc@2x.jpg")
    }
  }) : (this.Howlang == 'cn') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step3_sc@2x.jpg")
    }
  }) : (this.Howlang == 'en') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step3_en@2x.jpg")
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "HowTobuy_step"
  }, [_c('div', {
    staticClass: "HowTobuy_step_detail"
  }, [_c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('howtobuy_step4')) + "\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('howtobuy_step4_content1')) + "\n                ")])]), _vm._v(" "), (this.Howlang == 'sc') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step4_1tc@2x.jpg")
    }
  }) : (this.Howlang == 'cn') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step4_1sc@2x.jpg")
    }
  }) : (this.Howlang == 'en') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step4_1en@2x.jpg")
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "HowTobuy_step_detail"
  }, [_c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('howtobuy_step4_content2')) + "\n                ")])]), _vm._v(" "), (this.Howlang == 'sc') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step4_2tc@2x.jpg")
    }
  }) : (this.Howlang == 'cn') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step4_2sc@2x.jpg")
    }
  }) : (this.Howlang == 'en') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step4_2en@2x.jpg")
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "HowTobuy_step_detail"
  }, [_c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('howtobuy_step4_content3')) + "\n                ")])]), _vm._v(" "), (this.Howlang == 'sc') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step4_3tc@2x.jpg")
    }
  }) : (this.Howlang == 'cn') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step4_3sc@2x.jpg")
    }
  }) : (this.Howlang == 'en') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step4_3en@2x.jpg")
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "HowTobuy_step"
  }, [_c('div', {
    staticClass: "HowTobuy_step_detail"
  }, [_c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('howtobuy_step5')) + "\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('howtobuy_step5_content')) + "\n                ")])]), _vm._v(" "), (this.Howlang == 'sc') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step5_tc@2x.jpg")
    }
  }) : (this.Howlang == 'cn') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step5_sc@2x.jpg")
    }
  }) : (this.Howlang == 'en') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step5_en@2x.jpg")
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "HowTobuy_step"
  }, [_c('div', {
    staticClass: "HowTobuy_step_detail"
  }, [_c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('howtobuy_step6')) + "\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('howtobuy_step6_content')) + "\n                ")])]), _vm._v(" "), (this.Howlang == 'sc') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step6_tc@2x.jpg")
    }
  }) : (this.Howlang == 'cn') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step6_sc@2x.jpg")
    }
  }) : (this.Howlang == 'en') ? _c('img', {
    staticStyle: {
      "float": "left",
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/howtobuy/step6_en@2x.jpg")
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "HowTobuy_step"
  }, [_c('div', {
    staticClass: "HowTobuy_step_detail"
  }, [_c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('howtobuy_step7')) + "\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('howtobuy_step7_content')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('div', {
    staticClass: "mogos"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/howtobuy/qr1@2x.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('mini_program')))])]), _vm._v(" "), _c('div', {
    staticClass: "mogos"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/howtobuy/qr2@2x.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('user_center_iapp_qrcode')))])]), _vm._v(" "), _vm._m(0, false, false)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "HowTobuy_step_detail"
  }, [_c('p', {
    staticClass: "font_mid"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('howtobuy_step7_content1')) + "："), _c('a', {
    staticStyle: {
      "color": "#0084ff"
    },
    attrs: {
      "href": "web.ifree.ly"
    }
  }, [_vm._v("web.ifree.ly")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "how_footer"
  }, _vm._l((_vm.suport), function(list, index) {
    return _c('div', {
      key: index,
      staticClass: "how_footer_list"
    }, [_c('span', [_c('img', {
      attrs: {
        "src": list.img,
        "width": "40"
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "font_mid",
      staticStyle: {
        "font-size": "14px",
        "margin-left": "25px"
      }
    }, [_vm._v("\n                    " + _vm._s(list.content) + "\n            ")])])
  }))], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iapp"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/howtobuy/ios@2x.png")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/howtobuy/android@2x.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04d2a3a6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HowTobuy.vue
// module id = 774
// module chunks = 0